export default "__VITE_ASSET__5030d725__"